import { render, staticRenderFns } from "./settingRoleIcon.vue?vue&type=template&id=34f0fe32&scoped=true"
import script from "./settingRoleIcon.vue?vue&type=script&lang=js"
export * from "./settingRoleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f0fe32",
  null
  
)

export default component.exports